import type { IconProps } from "./icon-types";

/**
 * 좌측 네비게이션 접기(collapse). 헤더의 nav 토글 등에서 펼쳐진 상태일 때 사용.
 *
 * 글리프는 sigmakit-gui가 쓰는 `react-icons/lu`의 `LuPanelLeftClose`(Lucide `panel-left-close`)를
 * 인라인으로 재현 — c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘).
 * 펼침/접힘 토글의 짝 아이콘은 PanelLeftOpenIcon.
 */
export const PanelLeftCloseIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <rect width="18" height="18" x="3" y="3" rx="2" />
    <path d="M9 3v18" />
    <path d="m16 15-3-3 3-3" />
  </svg>
);
